import Navbar from "../../components/general/Navbar";
import BuyerLoginForm from "../../components/buyers/BuyerLoginForm";
import Footer from "../../components/general/Footer";

export default function BuyerLoginPage() {
  return (
    <>
      <Navbar />
      <BuyerLoginForm />
      <Footer />
    </>
  )
}

